module.exports = function (elem, tolerance, callback) {
	var touches = {
		'touchstart': { 'x': -1, 'y': -1 },
		'touchmove': { 'x': -1, 'y': -1 },
		'touchend': false,
		'direction': 'undetermined'
	};

	elem.addEventListener('touchstart', handleEvent, false);
	elem.addEventListener('touchmove', handleEvent, false);
	elem.addEventListener('touchend', handleEvent, false);

	function handleEvent(event) {
		/*jshint maxcomplexity:10 */
		if (typeof event.touches === 'undefined') {
			return;
		}

		var touch = event.touches[0];
		switch (event.type) {
			case 'touchstart':
				touches[event.type].x = touch.pageX;
				touches[event.type].y = touch.pageY;
				break;
			case 'touchmove':
				touches[event.type].x = touch.pageX;
				touches[event.type].y = touch.pageY;
				break;
			case 'touchend':
				touches[event.type] = true;
				if (touches.touchmove.x === -1) {
					break;
				}
				var xDelta = Math.abs(touches.touchstart.x - touches.touchmove.x);
				var yDelta = Math.abs(touches.touchstart.y - touches.touchmove.y);

				if (xDelta > tolerance && yDelta < tolerance) {
					touches.direction = touches.touchstart.x < touches.touchmove.x ? 'right' : 'left';
					callback(event, touches.direction);
				}
				break;
		}
	}
};
